import AppointmentBanner from '@commons/cards/appointmentBanner'
import BannerImg from './banner.png'
import { useNavigate } from 'react-router-dom'
const Banner = () => {
  const navigate = useNavigate()
  return (
    <AppointmentBanner
      title="Create a New Appointment"
      bg="primary300"
      Img={BannerImg}
      description={`Set up consultations, follow-ups, or procedures in just a few clicks. Stay on top of patient care with a streamlined scheduling process.`}
      btnTitle={'Add New Appointment'}
      onClick={() => {
        navigate('/institution/appointments/create')
      }}
    />
  )
}

export default Banner
